module.exports = __webpack_public_path__ + "img/popup-bg.7dd7c3f8.svg";